<template>
  <page-content>
    <div slot="header">
      <h4 class="page-title-padding">每期人员信息维护</h4>
      <el-row style="margin-botton:20px">
        <el-col :span="3">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini" style="width:200px;">
              {{sele}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="assessDate[0]">{{assessDate[0]}}</el-dropdown-item>
              <el-dropdown-item :command="assessDate[1]">{{assessDate[1]}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="3">
          <el-button style="margin:0 auto;display: block" type="primary" :disabled="isOpen" @click="synchronization" size="mini">同步基础人员信息</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" :disabled="isOpen" :loading="syncLoading" @click="syncExaminee" size="mini">保存</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- <el-divider></el-divider> -->
    <div slot="content">
      <el-table ref="table" @sort-change="sortChange" :data="tableData" @filter-change="filterChange" v-loading="loading" show-summary :summary-method="getSummaries" style="width: 100%;" max-height="780" size="mini">
        <el-table-column sortable='custom' prop="examinee_name" column-key="examinee_name" :filters="filterData.examinee_name || []" label="被考评人" width="140" header-align="center" align="center"></el-table-column>
        <el-table-column sortable='custom' prop="group_name" column-key="group_name" :filters="filterData.group_name || []" label="组别" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column sortable='custom' prop="position_name" column-key="position_name" :filters="filterData.position_name || []" label="岗位" header-align="center" align="center"></el-table-column>
        <el-table-column sortable='custom' prop="examiner_name" column-key="examiner_name" :filters="filterData.examiner_name || []" label="考评人" header-align="center" align="center">
        </el-table-column>
        <el-table-column sortable='custom' prop="leader_name" column-key="leader_name" :filters="filterData.leader_name || []" label="负责人" header-align="center" align="center">
        </el-table-column>
        <el-table-column sortable='custom' prop="is_commissioner" column-key="is_commissioner" :filters="options2" label="是否专员" header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.is_commissioner==1?'是':'不是'}}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop="day" column-key="day" :filters="filterData.day || []" label="日班应出勤天数" width="140" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.amand" v-model="tableData1[scope.$index].day" size="mini"></el-input>
            <span v-else>{{scope.row.day}}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop="night" column-key="night" :filters="filterData.night || []" label="夜班应出勤天数" width="140" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.amand" v-model="tableData1[scope.$index].night" size="mini"></el-input>
            <span v-else>{{scope.row.night}}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop="template_name_created_by" column-key="template_name_created_by" :filters="setAssessFormListData(assessFormList)" label="考核评分表" width="120" header-align="center" align="center">
        </el-table-column>
        <el-table-column sortable='custom' prop="is_attendance" column-key="is_attendance" :filters="options1" label="状态" width="120" header-align="center" align="center">
          <template slot-scope="scope">
            <el-select v-if="scope.row.amand" v-model="tableData1[scope.$index].is_attendance" size="mini">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span v-else>{{scope.row.is_attendance==1?'参加':'不参加'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope)" :disabled="isOpen" type="text" size="mini">{{scope.row.amand?'取消':'编辑'}}</el-button>
            <el-button @click="saveSetting(scope)" type="text" size="mini" style="margin-left:20px" :disabled="!scope.row.amand">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <staff :visible="staffVisible" @confirmstaff="staffSele" @close="staffVisibles"></staff>
      <el-dialog :title="settingEvaluateDialog.title" :visible="settingEvaluateDialog.visible" width="400px" @close="evaluateDialogClose">
        <div>
          <p v-for="assessForm in assessFormList" :key="assessForm.id">
            <el-radio v-model="editRow.template_id_created_by" :label="assessForm.id">{{assessForm.name}}</el-radio>
          </p>
        </div>
        <div style="margin-top: 10px;text-align: center;">
          <el-button type="warning" size="mini" @click="evaluateDialogClose">取消</el-button>
          <el-button type="primary" size="mini" @click="changeEvaluateInfo">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </page-content>
</template>
<script>
import staff from '@/components/staff/Staff'
import pageContent from '@/components/pageContent'
import { currentAssessDate, computeAssessDate } from '@/assets/js/date'
import { multiFilter, listSort } from '@/assets/js/filtrate'
export default {
  data () {
    return {
      sele: '请选择考核期',
      assessDate: '',
      tableData: [],
      tableData1: [],              //修改数据
      initData: [],                //初始数据
      evaluateData: [],
      commissionerData: [],
      options1: [
        { value: 1, label: '参加', text: '参加' },
        { value: 0, label: '不参加', text: '不参加' },
      ],
      options2: [
        { value: 1, label: '是', text: '是' },
        { value: 0, label: '不是', text: '不是' },
      ],
      assessFormList: [],
      buttsele: '考核期',
      scopeExaminne: '',           //修改考评人，负责人数据
      scopeCurrentExaminer: '',    //考核期考评人修改数据
      loading: false,
      syncLoading: false,          //同步loading
      commLoading: false,          //专员列表loading
      examineeLoading: false,      //被考评人列表loading
      staffVisible: false,         //员工对话框
      settingEvaluateDialog: {
        visible: false,
        title: ''
      },
      editRow: {},
      isOpen: false,               //互评功能是否开放
      tableFilter: [],             //筛选条件数据
      filterData: [],              //筛选数据
      evaluateData1: [],           //筛选table数据
      tableSort: {},               //排序条件数据
    }
  },
  created () {
    this.assessDate = computeAssessDate();
    // this.sele=this.assessDate[0];
    this.getIsOpen();
    this.getAssessFormData();
    this.handleCommand(this.assessDate[0])
  },
  methods: {
    sortChange ({ column, order, prop }) {   // 排序
      this.tableSort = { column, order, prop };
      let isFilter = true;
      this.tableFilter.forEach((v, index) => {           //查询是否存在筛选条件
        const $key = Object.keys(v)
        if (v[$key].length) isFilter = false;
      })
      const initData = JSON.parse(JSON.stringify(isFilter ? this.initData : this.evaluateData1));
      const param = listSort([...initData], { order, prop });
      this.tableData = this.tableData1 = param;
    },
    filterChange (data) { //筛选
      const initData = JSON.parse(JSON.stringify(this.initData));
      if (data) {
        const val = Object.keys(data);
        if (this.tableFilter.length === 0) {        //保存全部筛选数据
          this.tableFilter.push(data)
        } else {
          let isKey = true;
          this.tableFilter.forEach((v, index) => {
            const $key = Object.keys(v)
            if (val[0] === $key[0]) isKey = index;
          })
          isKey === true ? (this.tableFilter.push(data)) : (this.tableFilter.splice(isKey, 1, data))
        }
      }
      this.tableData = this.tableData1 = this.evaluateData1 = multiFilter(initData, this.tableFilter);
      if (this.tableSort.order != null) {     //排序存在
        this.sortChange(this.tableSort)
      }
      // this.$refs.table.clearSort()            //清除排序    
    },
    getSummaries () { //页尾
      return [`共${this.tableData.length}条数据`]
    },
    handleCommand (v) {               //考核期选择
      this.loading = true;
      this.sele = v;
      this.buttsele = '考核期'
      this.getTableData(v);
    },
    getTableData (param) {            //获得考核期列表
      if (this.tableData.length === 0) {
        this.loading = true;
      }
      const assessDate = param.split('/');
      this.$http.get('assessment/getList', { params: { start: assessDate[0], end: assessDate[1] } }).then((v) => {
        if (v.status === 200) {
          this.tableData = v.data.data;
          //用于编辑取消
          this.tableData1 = JSON.parse(JSON.stringify(v.data.data));
          //用于初始数据
          this.initData = JSON.parse(JSON.stringify(v.data.data));
          this.setAllFilterData(JSON.parse(JSON.stringify(v.data.data)));
          if (this.tableFilter.length) this.filterChange(false);
        }
        this.loading = false;
      }).catch((v) => { this.loading = false; })
    },
    setAllFilterData (data) {     //获得筛选数据
      let filterData = {
        group_name: [],
        position_name: [],
        leader_name: [],
        examinee_name: [],
        day: [],
        night: [],
        template_name_created_by: [],
        is_attendance: [],
        examiner_name: [],
      };
      for (let i in filterData) {
        data.forEach(v => {
          if (!filterData[i].some(item => item.text === v[i])) {
            filterData[i].push({
              text: v[i],
              value: v[i],
            });
          }
        })
      }
      this.filterData = filterData;
    },
    getIsOpen () {                    //已开放互评，不可编辑，保存
      const param = {
        start: computeAssessDate()[0].split('/')[0],
        end: computeAssessDate()[0].split('/')[1],
        department_id: this.$store.state.login.userinfo.department_id,
        flow_type: 1,
      }
      this.$http.get('/flow/isOpen', { params: param }).then(v => {
        if (v.status === 200) {
          this.isOpen = v.data.status;
        }
      }).catch(v => { })
    },
    syncExaminee () {                 //同步被考评人
      if (this.sele === '请选择考核期') {
        this.$message({
          message: '请选择考核期!',
          type: 'warning'
        });
        return
      }
      const date = this.sele.split('/');
      const params = {
        start_date: date[0],
        end_date: date[1]
      }
      this.syncLoading = true;
      this.$http.post('mutualEvaluation', params).then((v) => {
        if (v.status === 200) {
          this.$message({ message: v.data.message, type: 'success' })
        }
        this.syncLoading = false;
      }).catch((v) => { this.syncLoading = false; })
    },
    handleClick (scope) {            //编辑
      const tableData = JSON.parse(JSON.stringify(this.tableData)),
        tableData1 = JSON.parse(JSON.stringify(this.tableData1)),
        originalData = tableData.find(v => scope.row.assessment_id === v.assessment_id);
      if (scope.row.amand) {
        originalData.amand = false;

      } else {
        originalData.amand = true;
      }
      tableData1.map((v, index) => {
        if (scope.row.assessment_id === v.assessment_id) {
          this.tableData1.splice(index, 1, { ...originalData })
        }
      });
      this.tableData = tableData;
    },
    saveSetting (scope) {             //保存
      const $id = scope.row.assessment_id,
        tableData = this.tableData,
        tableData1 = this.tableData1.find(v => scope.row.assessment_id === v.assessment_id);
      const params = {
        assessment_id: tableData1.assessment_id,
        is_attendance: tableData1.is_attendance,
        day: tableData1.day,
        night: tableData1.night,
        examiner_id: tableData1.examiner_id,
        examinee_id: tableData1.examinee_id,
        is_commissioner: tableData1.is_commissioner,
        leader_id: tableData1.leader_id,
        template_id_created_by: tableData1.template_id_created_by,
      }
      this.loading = true;
      this.$http.put('assessment/setAssessmentInfo', params).then((v) => {
        if (v.status === 200 && v.data.status) {
          this.getTableData(this.sele);
          this.$message({ message: v.data.message, type: 'success' });
        } else {
          this.$message({ message: v.data.message, type: 'error' })
        }
      }).catch((v) => { this.loading = false; })
    },
    currentExaminer (scope, type) {    //当前考核期考评人选择
      this.scopeCurrentExaminer = { ...scope, amendName: type };
      this.staffVisibles();
    },
    staffSele (v, name) {              //职员选择
      this.amandSeleAssess(v, name)
    },
    amandSeleAssess (v, name) {        //当前考核期考评人修改
      const scope = this.scopeCurrentExaminer;
      let param = '';
      if (scope.amendName == 'examiner_name') {
        param = { examiner_id: v[0], examiner_name: name[0] }
      } else if (scope.amendName == 'leader_name') {
        param = { leader_id: v[0], leader_name: name[0] }
      }
      this.tableData1.forEach((v, index) => {
        if (scope.row.assessment_id === v.assessment_id) {
          this.tableData1.splice(index, 1, { ...v, ...param })
        }
      });
      this.staffVisibles();
    },
    staffVisibles () {               //职员（对话框）
      this.staffVisible = !this.staffVisible;
    },
    setAssessFormListData (data) {    //设置考核表筛选数据
      data.map(v => {
        v.text = v.name;
        v.value = v.name
      })
      return data
    },
    getAssessFormData () {
      this.$http.get('maintain/template')
        .then((res) => {
          if (res.status === 200) {
            let assessFormList = res.data.data;
            let department_id = this.$store.state.login.userinfo['department_id'];
            this.assessFormList = assessFormList.filter((item) => {
              return department_id == item.department_id;
            });
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    settingTemplate (scope) {
      let rowJson = JSON.stringify(scope.row);
      this.editRow = JSON.parse(rowJson);
      this.scopeCurrentExaminer = scope;
      this.settingEvaluateDialog.title = '选择考核评分表';
      this.settingEvaluateDialog.visible = true;
    },
    evaluateDialogClose () {
      this.settingEvaluateDialog.visible = false;
    },
    changeEvaluateInfo () {
      let assessFormName = ''
      for (let i = 0; i < this.assessFormList.length; i++) {
        if (this.assessFormList[i].id == this.editRow.template_id_created_by) {
          assessFormName = this.assessFormList[i].name;
          break;
        }
      }
      let assessFormId = this.editRow.template_id_created_by;
      const scope = this.scopeCurrentExaminer;
      this.tableData1.map((v, index) => {
        if (scope.row.assessment_id === v.assessment_id) {
          this.tableData1.splice(index, 1, { ...v, template_id_created_by: assessFormId, template_name_created_by: assessFormName })
        }
      });
      this.evaluateDialogClose();
    },
    //同步
    synchronization () {
      if (this.sele === '请选择考核期') {
        this.$message({
          message: '请选择考核期!',
          type: 'warning'
        });
        return
      }
      const assessDate = this.sele.split('/');
      this.$http.get('assessment/updateList', { params: { start: assessDate[0], end: assessDate[1] } }).then((v) => {
        if (v.status === 200 && v.data.status) {
          this.$message({ message: v.data.message, type: 'success' })
          this.getTableData(this.sele)
        } else {
          this.$message.error('同步失败')
        }
      }).catch((v) => { this.$message.error('同步失败') })
    },
  },
  components: {
    staff,
    pageContent
  },
}
</script>
<style scoped>
.el-button {
  font-size: 14px;
}
</style>


